import React, { Component } from 'react'
import { VerticalRow } from '../../utils/Grid'
import LeafletBox from '../../boxes/LeafletBox'
import styled from 'styled-components'
import { SIZES } from '../../../constants'
import utmLinkGenerator from '../../utils/UTMLinkGenerator'

const LeafletRow = styled(VerticalRow)`
  display: -ms-flexbox;
  -ms-flex-direction: row;
  -ms-flex-pack: justify;
  -ms-flex-wrap: wrap;

  @media (max-width: ${SIZES.BREAKPOINT_MD - 1}px) {
    flex-flow: wrap;
    align-content: stretch;
  }
`

export default class LeafletsContainer extends Component {
  render () {
    const {
      boxes,
      imageSize,
      utmParams,
      handleAnchorClick
    } = this.props

    if (!boxes.length) return null

    return (
      <LeafletRow>
        {
          boxes.map((box, index) => {
            const {
              guid,
              images,
              link,
              title
            } = box

            const utmLink = utmLinkGenerator.createLinkWithOriginalQuery(link, utmParams)

            return <LeafletBox
              key={guid}
              image={images[imageSize]}
              imageClass={`image-${imageSize}`}
              link={utmLink}
              position={index}
              title={title}
              handleAnchorClick={handleAnchorClick}
              guid={guid}
            />
          })
        }
      </LeafletRow>
    )
  }
}
